import "Bacon";
import c from "common";
import $ from "jquery";
import ga from "analytics";

function trackMobileLinks($target) {
  ga.trackWithSection("mobile-link", $target.data("service-name"), {
    useBeacon: true
  });
}

function initListeners() {
  $("body").asEventStream("click", ".mobile-links a").doAction(c.stopEvent).map(c.$currentTarget).doAction(trackMobileLinks).onValue(function ($target) {
    window.location.href = $target.attr("href");
  });
}

export default {
  init: c.setup(initListeners)
};



// WEBPACK FOOTER //
// ./web/js/mobile-links.js